import React, { useState, useEffect } from "react";
import moment from "moment";
import { useLocation } from "react-router-dom";
import { Box, Grid } from "@mui/material";
import { connect, useSelector } from "react-redux";
import { mapVtrStateToProps } from "../../services/mapStateToProps";
import Spinner from "../../components/common/Spinner";
import DefaultButton from "../../components/DefaultButton";
import {
  dateTimeSavedToDisplay,
  getCurrentOpenTrip,
} from "../../constants/vtrTrip";
import TripReviewRedirect from "../../components/TripReviewRedirect";
import SailDate from "../../components/SailDate";
import { mapDispatchToProps } from "../../constants/dispatchNewTripForm";
import { validateTripSet3 } from "../../constants/tripValidations";
import { success } from "../../constants/colors";

function DateSail({ actions, ...props }) {
  const { auth, vtrTrip } = useSelector((state) => state);
  const location = useLocation();
  const [display_date_sail, setDisplayDateSail] = useState(null);
  const [date_sail, setDateSail] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);

  const _cancel = (event, value) => {
    event.preventDefault();
    actions.setError([]);
    if (value === "Cancel") {
      actions.setTripRedirect();
    }
  };

  const _next = (event, value) => {
    event.preventDefault();
    const errors = validateTripSet3({ display_date_sail, date_sail, isLoaded });
    actions.setError(errors);
    if (errors.length > 0) {
      console.info("sailDatePage", errors);
      return;
    }
    if (value === "Save") {
      actions.updateTrip(
        { display_date_sail, date_sail, isLoaded },
        auth.client_id,
        location.state.trip_id
      );
    }
  };

  const handleSailDateChange = (date) => {
    if (date && date.hasOwnProperty("_d")) {
      let newDateTime = date._d;
      if (newDateTime !== "") {
        const dt = moment(newDateTime, "DD-MM-YYYY LT");
        let bDateTime = dt.format("YYMMDDHHmm");
        setDisplayDateSail(newDateTime);
        setDateSail(bDateTime);
      } else {
        setDisplayDateSail(newDateTime);
        setDateSail("");
      }
    }
  };

  const sailDateNowHandler = (event) => {
    event.preventDefault();
    let d = moment();
    const format = "DD-MMM-YY LT";
    const ndate_sail = d.format("YYMMDDHHmm");
    const ndisplay_date_sail = d.format(format);
    setDateSail(ndate_sail);
    setDisplayDateSail(ndisplay_date_sail);
  };

  useEffect(() => {
    const tripId = location.state.trip_id;
    const allOpenTrips = vtrTrip.allOpenTrips;
    const currentTrip = getCurrentOpenTrip(allOpenTrips, tripId);

    if (currentTrip && currentTrip.date_sail) {
      const displayDateSail = dateTimeSavedToDisplay(currentTrip.date_sail);
      setDateSail(currentTrip.date_sail);
      setDisplayDateSail(displayDateSail);
      setIsLoaded(true);
    }
  }, [location.state.trip_id, vtrTrip.allOpenTrips]);

  if (isLoaded === false) {
    return <Spinner />;
  }

  if (props.vtrTrip.redirect === true) {
    return (
      <TripReviewRedirect
        trip_id={location.state.trip_id}
        client_id={auth.client_id}
      />
    );
  }
  return (
    <div className="trip-form-container">
      <SailDate
        handleSailDateChange={handleSailDateChange}
        display_date_sail={display_date_sail}
        sailDateNowHandler={sailDateNowHandler}
        helpText={props.helpText.helpText}
      />
      <Box mt={5} width="100%" align="center" className="bottom-nav-container">
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs="auto" className="margRight20">
            <DefaultButton changeHandler={_cancel} buttonText={"Cancel"} />
          </Grid>
          <Grid item xs="auto">
            <DefaultButton
              changeHandler={_next}
              buttonText={"Save"}
              bgColor={success}
            />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}

export default connect(mapVtrStateToProps, mapDispatchToProps)(DateSail);
